import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCloudUpload, faPaperclip } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faLinkedin, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'

library.add(faCloudUpload, faPaperclip, faFacebook, faLinkedin, faInstagram, faYoutube)

export { FontAwesomeIcon } 